import React from "react";
import qs from "query-string";

const verifyRoute = (path, modulesList) => {
  modulesList = modulesList || [];
  let query = window.location.search;
  let moduleName = qs.parse(query).moduleId;
  let home = modulesList.find((each) => each.moduleId === "HOME");
  let { moduleId = "DS", link = "" } = home || {};
  path = path.split('?')[0] + `?moduleId=${moduleName}`;


  if (moduleName) {
    for (let i of modulesList) {
      let { tabs = [], moduleId = "" } = i;
      if (moduleId === moduleName && tabs.length) {
        for (let j of tabs) {
          let { link = "" } = j;
         
          if(j['subTabs']){
            for(let k of j['subTabs']){
              let { link = "" } = k;
              if (link === path) {
                return { moduleId, moduleObject: i, link, isRedirectToHome: false };
              }
            }
          }
          
          if (link === path) {
            return { moduleId, moduleObject: i, link, isRedirectToHome: false };
          }
        }
      } else if (moduleId === moduleName && !tabs.length) {
          return { moduleId, moduleObject: i, link: i.link };
      }
    }
  }

  return {
    moduleId: moduleId,
    moduleObject: home,
    link: link,
    isRedirectToHome: true,
  };
  // return { moduleId: "HOME", moduleObject:  }
  // modulesList = modulesList || [];
  // for (let i of modulesList) {
  //   let { moduleId: moduleIdKey = "", tabs = [] } = i || {};
  //   if (moduleId === moduleIdKey) {
  //     for (let j of tabs) {
  //       let { link = "" } = j;
  //       if (link === path) {
  //         return { moduleId, moduleObject: i, link };
  //       }
  //     }
  //   }
  // }

  // for (let i of modulesList) {
  //   let { tabs = [], moduleId } = i || {};
  //   for (let j of tabs) {
  //     let { link = "" } = j;
  //     if (link === path) {
  //       return { moduleId, moduleObject: i, link };
  //     }
  //   }
  // }
};

export default verifyRoute;
